import {
  TRoomsState,
  TRoomsActions,
  TParticipant,
  TMessage,
  roomsActionTypes,
} from '../../types/rooms';

const initialState: TRoomsState = {
  rooms: [],
  currentRoom: null,
  participants: [],
  messages: [],
  loading: false,
  disabledSubmit: false,
};

export default (state: TRoomsState = initialState, action: TRoomsActions): TRoomsState => {
  switch (action.type) {
    case roomsActionTypes.JOIN_ROOM_SUCCESS:
      return {
        ...state,
        messages: action.payload.messages,
        currentRoom: action.payload.currentRoom,
        disabledSubmit: action.payload.disabledSubmit,
      };

    case roomsActionTypes.SET_PARTICIPANTS:
      if (state.participants.find((participant) => participant.jid === action.payload.jid)) {
        return {
          ...state,
        };
      } else {
        return {
          ...state,
          participants: [...state.participants, action.payload],
        };
      }

    case roomsActionTypes.REMOVE_PARTICIPANT:
      return {
        ...state,
        participants: [...state.participants].filter(
          (participant) => participant.jid !== action.payload.jid,
        ),
      };

    case roomsActionTypes.ADD_MESSAGE_SUCCESS:
      return {
        ...state,
        messages: action.payload,
      };

    case roomsActionTypes.LEAVE_ROOM_SUCCESS:
      return {
        ...initialState,
      };

    case roomsActionTypes.GET_ROOMS_SUCCESS:
      return {
        ...state,
        rooms: action.payload,
      };

    case roomsActionTypes.SET_ROOMS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};

export const actions = {
  setParticipants: (payload: TParticipant) => ({
    payload,
    type: roomsActionTypes.SET_PARTICIPANTS,
  }),
  removeParticipant: (payload: TParticipant) => ({
    payload,
    type: roomsActionTypes.REMOVE_PARTICIPANT,
  }),
  addMessageRequest: (payload: TMessage) => ({
    payload,
    type: roomsActionTypes.ADD_MESSAGE_REQUEST,
  }),
  leaveRoomRequest: () => ({ type: roomsActionTypes.LEAVE_ROOM_REQUEST }),
  getRoomsRequest: () => ({ type: roomsActionTypes.GET_ROOMS_REQUEST }),
  joinRoomRequest: (payload: string) => ({ payload, type: roomsActionTypes.JOIN_ROOM_REQUEST }),
  unsubscribe: (payload: string) => ({ payload, type: roomsActionTypes.UNSUBSCRIBE_ROOM }),
  subscribeToRoom: (payload: { roomId: string }) => ({
    payload,
    type: roomsActionTypes.SUBSCRIBE_TO_ROOM,
  }),
};
